var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"icon":"ico icon-floppy","type":"primary","disabled":_vm.disabled,"data-qa":"save-button"},on:{"click":function($event){return _vm.click()}}},[_vm._v("\n  "+_vm._s(_vm.$t('RestForm_Save'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fceff32e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/form/SaveButton.vue
// module id = null
// module chunks = 